import { companyShortNameVar } from '@apolloClient/reactiveVars';

export const ROUTE_PAYMENT_AND_DEBT = '/account/payment';

export const ROUTE_INSTANTDEAL_V2 = 'instantdeal_v2';
export const ROUTE_CART_V2 = 'cart_v2';
export const ROUTE_CHECKOUT_V2 = 'checkout_v2';
export const ROUTE_MY_PRODUCT_V2 = 'my-products';

export const ROUTE_INSTANTDEAL = 'instantdeal';
export const ROUTE_CART = 'cart';
export const ROUTE_CHECKOUT = 'checkout';

export const WARRANTY_PAGE_URL = 'hau-mai';

export const getCompanyBasedRoute = (page: string) => {
  return `/${companyShortNameVar()}/${page}`;
};

export const getWarrantyPageRoute = (page: string) => {
  return `/${WARRANTY_PAGE_URL}/${page}`;
};
